<template>
  <div id="app"> 
    <div id="nav" v-if="this.$route.name != 'cotizacion'">
      <b-navbar toggleable="lg" class="bg-createch">
        <b-navbar-brand href="#">
          <a class="navbar-brand mr-auto mr-lg-0" href="#">
              <img src="./assets/img/logo.svg" height="60" width="auto" alt="">
            </a>
        </b-navbar-brand> 
        <b-navbar-toggle target="nav-collapse" v-if="logueado"></b-navbar-toggle> 
        <b-collapse id="nav-collapse" is-nav> 
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto" v-if="logueado">
            <router-link class="nav-link" to="/profile" v-if="!['cotizacion_id', 'cotizacion_confirmado'].includes($route.name)" style=" color: #00AB63 ;height:25px; padding:3px 10px; margin:0px;">
              <i class="far fa-user-circle" style="font-size:30px; color: #00AB63 ;"></i>
            </router-link>
            <a class="nav-link boton_createch_2" @click="salir()" v-if="!['cotizacion_id', 'cotizacion_confirmado'].includes($route.name)">Cerrar sesión</a> 
            <router-link class="nav-link boton_createch_2" to="/inicio" v-if="['cotizacion_id', 'cotizacion_confirmado'].includes($route.name)">Regresar</router-link>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      
      <div v-if="logueado && !['cotizacion', 'cotizacion_id', 'cotizacion_confirmado'].includes($route.name)" class="nav-scroller menu_superior">
    
        <nav :id="['cotizacion', 'cotizacion_id'].indexOf($route.name) ? 'menu' : 'menu_cotizador'" class="nav nav-underline">
          <router-link class="nav-link" active-class="active" to="/inicio" v-if="!['cotizacion', 'cotizacion_id', 'cotizacion_confirmado'].includes($route.name)">Inicio</router-link>
          <!-- <router-link class="nav-link" active-class="active" to="/pago">Pago</router-link> -->
          <router-link class="nav-link" active-class="active" to="/cotizacion" v-if="(logueado && esVendedor() && this.$route.name != 'cotizacion')">Cotización</router-link>
          <router-link class="nav-link" active-class="active" to="/clientes" v-if="(logueado && esVendedor() && this.$route.name != 'cotizacion')">Clientes</router-link> 

 
          <!--
          <router-link class="nav-link" active-class="active" to="/clientes">Clientes</router-link>
          <router-link class="nav-link" active-class="active" to="/empleados">Empleados</router-link>
          <router-link class="nav-link" active-class="active" to="/tarifas">Tarifas</router-link>
          <router-link class="nav-link" active-class="active" to="/cotizacion" style="font-weight:bold; color:  #00AB63;">Cotización</router-link> 
          <a class="nav-link" href="#">
          Friends
          <span class="badge badge-pill bg-light align-text-bottom">27</span>
          </a>
          <a class="nav-link" href="#">Explore</a>
          <a class="nav-link" href="#">Suggestions</a> 
          <a class="nav-link" href="#">Link</a>
          <a class="nav-link" href="#">Link</a>
          <a class="nav-link" href="#">Link</a>
          <a class="nav-link" href="#">Link</a>
          <a class="nav-link" href="#">Link</a>
          -->
        </nav>
      </div> 
    </div>
    <b-container fluid> 
      <b-row  :class="logueado ? '' : 'justify-content-md-center'">
        <nav class="col-md-2 d-none d-md-block menu_lateral sidebar" v-if="logueado && !esVendedor() && !['cotizacion', 'cotizacion_id', 'cotizacion_confirmado'].includes($route.name)">
 
          <div class="sidebar-sticky">
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>Ventas</span> 
            </h6>
            <ul class="nav flex-column"> 
              <li class="nav-item">
                <router-link class="nav-link"  :to="{ name:'cotizacion'}">
                <i class="fas fa-file-alt"></i>
              Cotización
              
              </router-link>
              </li> 
              <li class="nav-item" v-if="esAdministrador()"> 
                <router-link class="nav-link"  :to="{ name:'Ordenes'}">
                <i class="fas fa-file-alt"></i>
              Ordenes
              <OrdersCount/>
              </router-link>
              </li> 
            </ul> 
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted" v-if="esAdministrador()">
              <span>Productos/Servicios</span> 
            </h6>
            <ul class="nav flex-column" v-if="esAdministrador()"> 
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/products">
                <i class="fas fa-cube"></i>
              Productos
              </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/paquetes">
                <i class="fas fa-cubes"></i>
              Paquetes
              </router-link>
              </li>     
            </ul>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted" v-if="esAdministrador()">
              <span>Recursos</span> 
            </h6>
            <ul class="nav flex-column" v-if="esAdministrador()"> 
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/tarifas">
                <i class="fas fa-hand-holding-usd"></i>
              Tarifas
              </router-link>
              </li>  
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/marcas">
                <i class="far fa-copyright"></i>
              Marcas
              </router-link>
              </li>  
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/ciudades">
                <i class="fas fa-map-marker-alt"></i>
              Ciudades
              </router-link>
              </li> 
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/empresas"> 
                <i class="far fa-building"></i>
              Empresas
              </router-link>
              </li>  
              <li class="nav-item"  v-if="esAdministrador()">
                <router-link class="nav-link" active-class="active" to="/data">  
              Datos Cotizaciones
              </router-link>
              </li>  
            </ul>
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>Usuarios</span> 
            </h6>
            <ul class="nav flex-column"> 
              <li class="nav-item">
                <router-link class="nav-link" active-class="active" to="/clientes">
                <i class="far fa-user"></i>
              Clientes
              </router-link>
              </li> 
              <li class="nav-item" v-if="esAdministrador() || esSupervisor()">
                <router-link class="nav-link" active-class="active" to="/empleados">
                <i class="fas fa-users"></i>
              Empleados
              </router-link>
              </li>  
              <li class="nav-item" v-if="esAdministrador()">
                <router-link class="nav-link" active-class="active" to="/NoServicio">
                No. Servicio
              </router-link>
              </li>  
            
            </ul>
          </div> 
        </nav>
        <main :class="((logueado && !esVendedor() && !['cotizacion', 'cotizacion_id', 'cotizacion_confirmado'].includes($route.name))) ? 'ml-sm-auto col-lg-10 px-4 col-md-10' : 'col-sm-12'" style="padding-left:0px; padding-right:0px;">
            <router-view/>
        </main>
      </b-row> 
    </b-container>
  
  </div>
</template>

<style>
html,
body {
  overflow-x: hidden; /* Prevent scroll on narrow devices */
  background-color: #f8f9fa !important;
}
 
footer{
  background-color: #00AB63 ;
}
.menu_superior {
  background-color: #f3f3f3 !important;
}
.menu_superior nav a {
  font-family: 'Karla', sans-serif;
  font-weight: 700 !important; 
  color: #000 !important;
}
.menu_lateral {
  background-color: #fff !important;
  border: 0 !important;
  box-shadow: none !important;
}
.menu_lateral a.nav-link {
  font-family: 'Karla', sans-serif;
  font-weight: 700 !important; 
  color: #444 !important;
}
.menu_lateral a.nav-link.active { 
  color: #00AB63 !important;
}
.boton_createch {
  border-color:  #00AB63  !important;
  background-color: #00AB63  !important;
  border-radius: 60px !important; 
  font-weight: 700 !important;  
  font-size: 14px !important;
}
.boton_createch_2 {
  border-color:  #00AB63  !important;
  border: 2px solid #00AB63  !important;
  background-color: #fff  !important;
  color: #00AB63 !important;
  padding: 5px 20px !important;
  border-radius: 60px !important; 
  font-weight: 700 !important;  
  font-size: 14px !important;
}
.boton_createch_2:hover { 
  background-color: #00AB63  !important;
  color: #fff !important; 
}
.btn_borrar {
    border-color:  #fff  !important;
  background-color: #fff  !important;
  color: #FF8181 !important;
}
.btn_editar {
  border-color:  #fff  !important;
  background-color: #fff  !important;
  color: #6A6A6A !important;
}
.page-item.active .page-link {
   background-color: #00AB63  !important;
   border-color: #00AB63  !important;
   border-radius: 60px !important; 
   color: #fff !important;
}
.page-item .page-link {
   background-color: transparent  !important;
   border-color: transparent  !important; 
   color: #6A6A6A !important;
}
.page-item .page-link:focus {
  box-shadow: none !important;
}
ul.pagination  {
 border: 1px solid #E0E0E0 !important;
border-radius: 60px !important;
}
#login .form-group{
  margin-top: 35px !important;
}
#login .col-form-label {
    font-family: 'Karla', sans-serif !important;
  font-weight: 700 !important; 
}
.form-control,
.custom-select,
.custom-file-input,
.custom-file-label {
  background-color: #f5f5f5  !important;
  border-color: #f5f5f5  !important;
  border-radius: 60px !important;
}
.custom-file-label::after {
    background-color: #00AB63  !important;
   border-color: #00AB63  !important;
  -webkit-border-top-right-radius: 60px  !important;
-webkit-border-bottom-right-radius: 60px !important;
-moz-border-radius-topright: 60px !important;
-moz-border-radius-bottomright: 60px !important;
border-top-right-radius: 60px !important;
border-bottom-right-radius: 60px !important;
color: #fff !important;
}
#filterInput.form-control {
  background-color: #f5f5f5  !important;
  border-color: #f5f5f5  !important;
  -webkit-border-top-left-radius: 60px !important;
  -webkit-border-bottom-left-radius: 60px !important;
  -moz-border-radius-topleft: 60px !important;
  -moz-border-radius-bottomleft: 60px !important;
  border-top-left-radius: 60px !important;
  border-bottom-left-radius: 60px !important;
}
/*
 * Sidebar
 */

.sidebar { 
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100; /* Behind the navbar */
  padding: 0; /* Height of navbar */
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
    position: -webkit-sticky;
    position: sticky;
  }
}

.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.active {
  color: #007bff;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}
/*
 * Content
 */

[role="main"] {
  padding-top: 133px; /* Space for fixed navbar */
}

@media (min-width: 768px) {
  [role="main"] {
    padding-top: 48px; /* Space for fixed navbar */
  }
}

@media (max-width: 991.98px) {
  .offcanvas-collapse {
    position: fixed;
    top: 56px; /* Height of navbar */
    bottom: 0;
    left: 100%;
    width: 100%;
    padding-right: 1rem;
    padding-left: 1rem;
    overflow-y: auto;
    visibility: hidden;
    background-color: #343a40;
    transition: visibility .3s ease-in-out, -webkit-transform .3s ease-in-out;
    transition: transform .3s ease-in-out, visibility .3s ease-in-out;
    transition: transform .3s ease-in-out, visibility .3s ease-in-out, -webkit-transform .3s ease-in-out;
  }
  .offcanvas-collapse.open {
    visibility: visible;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  color: rgba(255, 255, 255, .75);
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.nav-underline .nav-link {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: .875rem;
  color: #6c757d;
}

.nav-underline .nav-link:hover {
  color: #007bff;
}

.nav-underline .active {
  font-weight: 500;
  color: #343a40;
}

.text-white-50 { color: rgba(255, 255, 255, .5); }

.bg-purple { background-color: #6f42c1; }

.lh-100 { line-height: 1; }
.lh-125 { line-height: 1.25; }
.lh-150 { line-height: 1.5; }

.bg-createch {
  background-color:  #fff;
}
</style>
<script>
 import axios from "axios";
 import OrdersCount from './components/OrdersCount'
export default {
  name: 'App',
  components: {
    OrdersCount
  },
  data () {
    return { 
      user:null,
      orders: [],
      drawer: true,
    }
  }, 
  computed:{
    logueado(){
      this.user = this.$store.state;
      return this.$store.state.usuario;
    },
    main(){ 
          return this.$route.path != '/cotizacion'
      }
  },
  created(){ 
    if(this.user != null && this.user.usuario.rol === "Administrador"){
      this.getOrders();
    } 
    this.$store.dispatch("autoLogin");
    
  },
  methods:{
    salir(){
      this.$store.dispatch("salir");
    },
    getOrders() { 
        axios
        .get("orders")
        .then(res => { 
            if (res.data) {  
                this.orders = res.data.filter(order => order.status == false); 
            } 
        })
        .catch(error => { 
            this.isLoading = false; 
        });
    },  
   
  }
}
</script>